import { Template } from '../../stores/builderStore';

export const premiumTemplates: Template[] = [
  // Netflix-Style Templates
  {
    id: 'netflix-hero-1',
    category: 'hero',
    name: 'Netflix Featured',
    description: 'Full-screen hero with video background and gradient overlay',
    thumbnail: '/templates/netflix-hero.jpg',
    config: {
      type: 'hero',
      variant: 'netflix',
      props: {
        title: 'Master UPSC Preparation',
        subtitle: 'FEATURED COURSE',
        description: 'Complete preparation strategy with expert guidance, mock tests, and comprehensive study materials.',
        buttonText: 'Start Learning',
        backgroundImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=1600',
        height: '600px'
      },
      styles: {
        backgroundColor: '#141414'
      },
      responsive: { desktop: true, tablet: true, mobile: true },
      animations: {
        type: 'fadeInUp',
        duration: 0.8
      }
    },
    is_premium: true
  },

  // App Store Style Templates
  {
    id: 'appstore-hero-1',
    category: 'hero',
    name: 'App Store Today',
    description: 'Featured card with parallax effect and gradient background',
    thumbnail: '/templates/appstore-hero.jpg',
    config: {
      type: 'hero',
      variant: 'appstore',
      props: {
        category: 'TODAY',
        title: 'Study Smarter, Not Harder',
        subtitle: 'Featured Collection',
        description: 'Discover AI-powered learning techniques that adapt to your pace',
        buttonText: 'Explore Now',
        accentColor: '#007AFF',
        backgroundImage: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1600'
      },
      styles: {},
      responsive: { desktop: true, tablet: true, mobile: true },
      animations: {
        type: 'appStoreCard',
        parallax: true
      }
    },
    is_premium: true
  },

  // Premium Feature Cards
  {
    id: 'premium-cards-netflix',
    category: 'features',
    name: 'Netflix Grid',
    description: 'Content cards with hover preview effect',
    thumbnail: '/templates/netflix-cards.jpg',
    config: {
      type: 'features',
      variant: 'netflix',
      props: {
        title: 'Popular Courses',
        columns: 4,
        items: [
          {
            id: '1',
            title: 'Indian History',
            subtitle: 'Complete Course',
            image: 'https://images.unsplash.com/photo-1604580864964-0462f5d5b1a8?w=400',
            badge: 'NEW',
            link: '#'
          },
          {
            id: '2',
            title: 'Geography',
            subtitle: 'World & Indian',
            image: 'https://images.unsplash.com/photo-1521295121783-8a321d551ad2?w=400',
            badge: 'TRENDING',
            link: '#'
          },
          {
            id: '3',
            title: 'Current Affairs',
            subtitle: 'Daily Updates',
            image: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=400',
            link: '#'
          },
          {
            id: '4',
            title: 'Mock Tests',
            subtitle: 'Practice Papers',
            image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=400',
            badge: 'HOT',
            link: '#'
          }
        ]
      },
      styles: {
        backgroundColor: '#141414'
      },
      responsive: { desktop: true, tablet: true, mobile: true }
    },
    is_premium: true
  },

  {
    id: 'premium-cards-appstore',
    category: 'features',
    name: 'App Store Cards',
    description: 'Beautiful cards with ratings and gradients',
    thumbnail: '/templates/appstore-cards.jpg',
    config: {
      type: 'features',
      variant: 'appstore',
      props: {
        title: 'Featured Resources',
        subtitle: 'Handpicked study materials for your success',
        columns: 3,
        items: [
          {
            id: '1',
            title: 'NCERTs Collection',
            subtitle: 'Class 6-12',
            description: 'Complete NCERT textbooks with notes and summaries',
            rating: 5,
            accentColor: '#5856D6',
            link: '#'
          },
          {
            id: '2',
            title: 'Previous Papers',
            subtitle: '10 Years Solved',
            description: 'Detailed solutions to past UPSC questions',
            rating: 4,
            accentColor: '#FF2D55',
            link: '#'
          },
          {
            id: '3',
            title: 'Video Lectures',
            subtitle: 'Expert Faculty',
            description: 'HD quality lectures from top educators',
            rating: 5,
            accentColor: '#007AFF',
            badge: 'POPULAR',
            link: '#'
          }
        ]
      },
      styles: {},
      responsive: { desktop: true, tablet: true, mobile: true }
    },
    is_premium: true
  },

  {
    id: 'premium-cards-glass',
    category: 'features',
    name: 'Glass Cards',
    description: 'Modern glassmorphism effect cards',
    thumbnail: '/templates/glass-cards.jpg',
    config: {
      type: 'features',
      variant: 'glass',
      props: {
        title: 'Why Choose Us',
        columns: 3,
        items: [
          {
            id: '1',
            title: 'Expert Guidance',
            description: 'Learn from India\'s top educators and UPSC toppers',
            image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=400',
            accentColor: '#667eea',
            link: '#'
          },
          {
            id: '2',
            title: 'Smart Analytics',
            description: 'Track your progress with detailed performance insights',
            image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400',
            accentColor: '#f093fb',
            link: '#'
          },
          {
            id: '3',
            title: '24/7 Support',
            description: 'Get instant help from our dedicated support team',
            image: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400',
            accentColor: '#4facfe',
            link: '#'
          }
        ]
      },
      styles: {
        backgroundColor: 'transparent'
      },
      responsive: { desktop: true, tablet: true, mobile: true }
    },
    is_premium: true
  },

  // Animated Hero Templates
  {
    id: 'animated-gradient-hero',
    category: 'hero',
    name: 'Animated Gradient',
    description: 'Dynamic gradient background with smooth animations',
    thumbnail: '/templates/gradient-hero.jpg',
    config: {
      type: 'hero',
      variant: 'gradient',
      props: {
        title: 'Welcome to Excellence',
        subtitle: 'Your Journey Starts Here',
        description: 'Join thousands of successful students on their path to success',
        buttonText: 'Get Started',
        height: '500px'
      },
      styles: {
        background: 'animated-gradient-bg'
      },
      responsive: { desktop: true, tablet: true, mobile: true },
      animations: {
        type: 'gradient',
        text: 'fadeInUp'
      }
    },
    is_premium: true
  },

  // Testimonial Carousel
  {
    id: 'testimonial-netflix',
    category: 'testimonials',
    name: 'Netflix Testimonials',
    description: 'Auto-playing testimonial carousel',
    thumbnail: '/templates/testimonials.jpg',
    config: {
      type: 'testimonials',
      variant: 'netflix',
      props: {
        title: 'Success Stories',
        autoPlay: true,
        items: [
          {
            id: '1',
            name: 'Priya Sharma',
            role: 'AIR 23, UPSC 2023',
            content: 'The structured approach and quality content made all the difference in my preparation.',
            image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200'
          },
          {
            id: '2',
            name: 'Rahul Kumar',
            role: 'AIR 45, UPSC 2023',
            content: 'Mock tests and analytics helped me identify and work on my weak areas effectively.',
            image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200'
          }
        ]
      },
      styles: {
        backgroundColor: '#0f0f0f'
      },
      responsive: { desktop: true, tablet: true, mobile: true }
    },
    is_premium: true
  },

  // CTA Sections
  {
    id: 'premium-cta-1',
    category: 'cta',
    name: 'Premium CTA',
    description: 'Eye-catching call-to-action with gradient',
    thumbnail: '/templates/cta.jpg',
    config: {
      type: 'cta',
      variant: 'premium',
      props: {
        title: 'Ready to Start Your Journey?',
        subtitle: 'Join 50,000+ students preparing with us',
        buttonText: 'Start Free Trial',
        buttonLink: '#signup'
      },
      styles: {
        background: 'mesh-gradient-bg',
        padding: '80px 20px'
      },
      responsive: { desktop: true, tablet: true, mobile: true },
      animations: {
        type: 'fadeInScale'
      }
    },
    is_premium: true
  },

  // Premium Content/Text Templates
  {
    id: 'content-magazine-1',
    category: 'content',
    name: 'Magazine Article',
    description: 'Multi-column magazine-style layout with drop caps',
    thumbnail: '/templates/magazine-content.jpg',
    config: {
      type: 'content',
      variant: 'magazine',
      props: {
        title: 'Understanding the Indian Constitution',
        subtitle: 'A comprehensive guide to the foundation of Indian democracy',
        columns: 2,
        items: [
          {
            id: '1',
            title: 'The Making of the Constitution',
            content: 'The Indian Constitution, adopted on January 26, 1950, is the longest written constitution of any sovereign country in the world. Dr. B.R. Ambedkar, known as the Father of the Indian Constitution, led the Drafting Committee that took nearly three years to complete this monumental document. The Constitution originally had 395 articles in 22 parts and 8 schedules.',
            author: 'Prof. Kumar Singh'
          },
          {
            id: '2',
            title: 'Fundamental Rights and Duties',
            content: 'Part III of the Constitution guarantees six fundamental rights to Indian citizens: Right to Equality, Right to Freedom, Right against Exploitation, Right to Freedom of Religion, Cultural and Educational Rights, and Right to Constitutional Remedies. The 42nd Amendment Act of 1976 added Fundamental Duties, making citizens aware of their responsibilities.',
            author: 'Prof. Kumar Singh'
          }
        ],
        accentColor: '#FF6B6B',
        titleSize: 'text-4xl',
        contentSize: 'text-base'
      },
      styles: {
        backgroundColor: '#FAFAFA',
        padding: '60px 20px'
      },
      responsive: { desktop: true, tablet: true, mobile: true }
    },
    is_premium: true
  },

  {
    id: 'content-blog-1',
    category: 'content',
    name: 'Blog Post',
    description: 'Clean blog article layout with images',
    thumbnail: '/templates/blog-content.jpg',
    config: {
      type: 'content',
      variant: 'blog',
      props: {
        title: 'Latest Current Affairs',
        items: [
          {
            id: '1',
            title: 'Economic Survey 2024: Key Highlights',
            date: 'March 15, 2024',
            image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=800',
            content: '<p>The Economic Survey 2024 presents a comprehensive analysis of India\'s economic performance and outlines the roadmap for sustainable growth. Key highlights include:</p><ul><li>GDP growth projected at 6.5-7% for FY 2024-25</li><li>Focus on manufacturing and infrastructure development</li><li>Digital economy contribution expected to reach $1 trillion by 2025</li><li>Emphasis on green energy transition and climate action</li></ul><p>The survey emphasizes the need for continued reforms in agriculture, education, and healthcare sectors to achieve inclusive growth.</p>',
            author: 'Editorial Team'
          }
        ],
        titleSize: 'text-3xl',
        contentSize: 'text-lg',
        showDivider: true
      },
      styles: {
        backgroundColor: 'white',
        padding: '40px 20px'
      },
      responsive: { desktop: true, tablet: true, mobile: true }
    },
    is_premium: true
  },

  {
    id: 'content-feature-1',
    category: 'content',
    name: 'Feature Story',
    description: 'Image and text side-by-side layout',
    thumbnail: '/templates/feature-content.jpg',
    config: {
      type: 'content',
      variant: 'feature',
      props: {
        title: 'Success Stories',
        subtitle: 'Inspiring journeys of UPSC toppers',
        items: [
          {
            id: '1',
            title: 'From Small Town to IAS',
            subtitle: 'The journey of perseverance and dedication',
            image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600',
            content: '<p>Coming from a small village in Bihar, Rahul Kumar\'s journey to becoming an IAS officer is nothing short of inspirational. Despite limited resources and infrastructure, his determination to serve the nation kept him motivated throughout his preparation.</p><p>"The key is consistency and smart work. I studied 8-10 hours daily, focusing on understanding concepts rather than rote learning," says Rahul, who secured AIR 47 in UPSC CSE 2023.</p>'
          },
          {
            id: '2',
            title: 'Breaking Barriers',
            subtitle: 'First generation learner achieves the dream',
            image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600',
            content: '<p>Priya Sharma, daughter of a farmer from Haryana, became the first graduate in her family and went on to crack UPSC in her second attempt. Her story demonstrates that with proper guidance and self-belief, any obstacle can be overcome.</p><p>"Online resources and free coaching initiatives helped me bridge the gap. Technology has democratized UPSC preparation," shares Priya, now serving as SDM in her home district.</p>'
          }
        ],
        imagePosition: 'left',
        titleSize: 'text-3xl',
        contentSize: 'text-base'
      },
      styles: {
        backgroundColor: '#F9FAFB',
        padding: '60px 20px'
      },
      responsive: { desktop: true, tablet: true, mobile: true }
    },
    is_premium: true
  },

  {
    id: 'content-faq-1',
    category: 'content',
    name: 'FAQ Section',
    description: 'Collapsible frequently asked questions',
    thumbnail: '/templates/faq-content.jpg',
    config: {
      type: 'content',
      variant: 'faq',
      props: {
        title: 'Frequently Asked Questions',
        subtitle: 'Everything you need to know about UPSC preparation',
        items: [
          {
            id: '1',
            title: 'What is the eligibility criteria for UPSC CSE?',
            content: '<p>To appear for UPSC Civil Services Examination, candidates must:</p><ul><li>Be a citizen of India (for IAS/IPS), or from Nepal/Bhutan for other services</li><li>Age: 21-32 years (relaxation for reserved categories)</li><li>Education: Bachelor\'s degree from a recognized university</li><li>Number of attempts: General - 6, OBC - 9, SC/ST - unlimited till age limit</li></ul>'
          },
          {
            id: '2',
            title: 'How should I start my UPSC preparation?',
            content: '<p>Begin your UPSC journey with these steps:</p><ol><li>Understand the exam pattern and syllabus thoroughly</li><li>Start with NCERT books (6th to 12th standard)</li><li>Read standard reference books for each subject</li><li>Make notes and revise regularly</li><li>Practice answer writing and take mock tests</li><li>Stay updated with current affairs through newspapers and magazines</li></ol>'
          },
          {
            id: '3',
            title: 'What is the exam pattern of UPSC CSE?',
            content: '<p>UPSC CSE consists of three stages:</p><ul><li><strong>Preliminary Exam:</strong> Two objective papers - GS Paper I (200 marks) and CSAT (200 marks, qualifying)</li><li><strong>Main Exam:</strong> 9 descriptive papers including 4 GS papers, 2 optional papers, Essay, and 2 language papers</li><li><strong>Personality Test:</strong> Interview of 275 marks testing mental alertness, critical powers of assimilation, and leadership qualities</li></ul>'
          }
        ],
        accentColor: '#3B82F6',
        titleSize: 'text-3xl'
      },
      styles: {
        backgroundColor: '#F3F4F6',
        padding: '60px 20px'
      },
      responsive: { desktop: true, tablet: true, mobile: true }
    },
    is_premium: true
  },

  {
    id: 'content-quote-1',
    category: 'content',
    name: 'Testimonials',
    description: 'Student testimonials and quotes',
    thumbnail: '/templates/quote-content.jpg',
    config: {
      type: 'content',
      variant: 'quote',
      props: {
        title: 'What Our Students Say',
        columns: 3,
        items: [
          {
            id: '1',
            content: 'The structured approach and comprehensive study materials provided by this platform were instrumental in my success. The mock tests helped me identify my weak areas and improve consistently.',
            author: 'Amit Verma',
            title: 'AIR 72, UPSC CSE 2023'
          },
          {
            id: '2',
            content: 'As a working professional, the flexibility of online classes and recorded lectures was a game-changer. I could prepare at my own pace without compromising my job.',
            author: 'Sneha Patel',
            title: 'IRS Officer, 2023 Batch'
          },
          {
            id: '3',
            content: 'The mentorship program connected me with successful officers who guided me through every stage of preparation. Their insights about the interview process were invaluable.',
            author: 'Rajesh Kumar',
            title: 'IPS Officer, 2023 Batch'
          }
        ],
        accentColor: '#10B981',
        titleSize: 'text-3xl',
        contentSize: 'text-lg'
      },
      styles: {
        backgroundColor: 'white',
        padding: '60px 20px'
      },
      responsive: { desktop: true, tablet: true, mobile: true }
    },
    is_premium: true
  },

  // Button Grid Templates
  {
    id: 'button-grid-quick-2',
    category: 'button_grid',
    name: 'Quick Actions',
    description: 'Two main action buttons for primary navigation',
    thumbnail: '/templates/button-grid-2.jpg',
    config: {
      type: 'button_grid',
      variant: 'gradient',
      props: {
        title: 'Quick Access',
        subtitle: 'Start your learning journey',
        titleSize: 'text-3xl',
        titleWeight: 'bold',
        titleAlign: 'left',
        subtitleSize: 'text-base',
        titleMarginBottom: 12,
        subtitleMarginBottom: 32,
        containerPadding: '32px',
        buttonTextSize: 'text-base',
        buttonPadding: '20px',
        iconSize: 'large',
        iconMargin: 12,
        columns: 2,
        gridSize: 2,
        gap: 16,
        buttons: [
          {
            id: 'btn-1',
            icon: '📚',
            title: 'Study Materials',
            subtitle: 'Access all resources',
            link: '/materials',
            linkType: 'internal',
            backgroundColor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
          },
          {
            id: 'btn-2',
            icon: '📝',
            title: 'Take Quiz',
            subtitle: 'Test your knowledge',
            link: '/quiz',
            linkType: 'internal',
            backgroundColor: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
          }
        ]
      },
      styles: {
        buttonHeight: '140px',
        borderRadius: '16px',
        shadowLevel: 'md'
      }
    },
    is_premium: true
  },

  {
    id: 'button-grid-horizontal-4',
    category: 'button_grid',
    name: 'Horizontal Buttons',
    description: 'Horizontal rectangular buttons with icon backgrounds (2x2 grid)',
    thumbnail: '/templates/button-horizontal-4.jpg',
    config: {
      type: 'button_grid',
      variant: 'horizontal',
      props: {
        title: 'Select your Goal',
        subtitle: 'Popular Exams',
        titleSize: 'text-2xl',
        titleWeight: 'bold',
        titleAlign: 'center',
        subtitleSize: 'text-lg',
        titleMarginBottom: 8,
        subtitleMarginBottom: 24,
        containerPadding: '24px',
        columns: 2,
        gridSize: 4,
        gap: 12,
        horizontalIconSize: 24,
        horizontalTextSize: 'text-sm',
        horizontalPadding: '12px',
        buttons: [
          {
            id: 'btn-1',
            icon: '⚛️',
            title: 'IIT-JEE',
            link: '/subjects/iit-jee',
            linkType: 'internal',
            backgroundColor: '#E3F2FD'
          },
          {
            id: 'btn-2',
            icon: '🔬',
            title: 'NEET',
            link: '/subjects/neet',
            linkType: 'internal',
            backgroundColor: '#E8F5E9'
          },
          {
            id: 'btn-3',
            icon: '🏛️',
            title: 'UPSC',
            link: '/subjects/upsc',
            linkType: 'internal',
            backgroundColor: '#FFF9C4'
          },
          {
            id: 'btn-4',
            icon: '🏅',
            title: 'Govt. Exams',
            link: '/subjects/govt-exams',
            linkType: 'internal',
            backgroundColor: '#FFEBEE'
          }
        ]
      },
      styles: {
        buttonHeight: '70px',
        borderRadius: '12px',
        shadowLevel: 'md'
      }
    },
    is_premium: true
  },

  {
    id: 'button-grid-horizontal-8',
    category: 'button_grid',
    name: 'All Exams Horizontal',
    description: 'Complete exam categories with horizontal layout (2x4 grid)',
    thumbnail: '/templates/button-horizontal-8.jpg',
    config: {
      type: 'button_grid',
      variant: 'horizontal',
      props: {
        title: 'All Exams',
        columns: 2,
        gridSize: 8,
        gap: 12,
        buttons: [
          {
            id: 'btn-1',
            icon: '⚛️',
            title: 'IIT-JEE & NEET',
            link: '/subjects/iit-jee-neet',
            linkType: 'internal',
            backgroundColor: '#E3F2FD'
          },
          {
            id: 'btn-2',
            icon: '🏆',
            title: 'Schools Exams & Olympiads',
            link: '/subjects/schools',
            linkType: 'internal',
            backgroundColor: '#FFF9C4'
          },
          {
            id: 'btn-3',
            icon: '🏛️',
            title: 'UPSC & State PSC',
            link: '/subjects/upsc',
            linkType: 'internal',
            backgroundColor: '#FFEBEE'
          },
          {
            id: 'btn-4',
            icon: '🏗️',
            title: 'CUET, CLAT, IPMAT, Design',
            link: '/subjects/entrance',
            linkType: 'internal',
            backgroundColor: '#FFF3E0'
          },
          {
            id: 'btn-5',
            icon: '🎖️',
            title: 'Defence & Govt Job Exams',
            link: '/subjects/defence',
            linkType: 'internal',
            backgroundColor: '#E0F2F1'
          },
          {
            id: 'btn-6',
            icon: '🎓',
            title: 'GATE, ESE, AE/JE, MBA',
            link: '/subjects/gate',
            linkType: 'internal',
            backgroundColor: '#F3E5F5'
          },
          {
            id: 'btn-7',
            icon: '💼',
            title: 'CA, CS, Banking & Finance',
            link: '/subjects/banking',
            linkType: 'internal',
            backgroundColor: '#E3F2FD'
          },
          {
            id: 'btn-8',
            icon: '📚',
            title: 'Study Materials',
            link: '/materials',
            linkType: 'internal',
            backgroundColor: '#E8F5E9'
          }
        ]
      },
      styles: {
        buttonHeight: '70px',
        borderRadius: '12px',
        shadowLevel: 'md'
      }
    },
    is_premium: true
  },

  {
    id: 'button-grid-study-4',
    category: 'button_grid',
    name: 'Study Categories',
    description: 'Four-button grid for subject navigation',
    thumbnail: '/templates/button-grid-4.jpg',
    config: {
      type: 'button_grid',
      variant: 'card',
      props: {
        title: 'Choose Your Subject',
        subtitle: 'Select a category to begin studying',
        columns: 2,
        gridSize: 4,
        gap: 16,
        buttons: [
          {
            id: 'btn-1',
            icon: '🏛️',
            title: 'History',
            link: '/subjects/history',
            linkType: 'internal',
            color: '#FF6B6B'
          },
          {
            id: 'btn-2',
            icon: '🌍',
            title: 'Geography',
            link: '/subjects/geography',
            linkType: 'internal',
            color: '#4ECDC4'
          },
          {
            id: 'btn-3',
            icon: '⚖️',
            title: 'Polity',
            link: '/subjects/polity',
            linkType: 'internal',
            color: '#45B7D1'
          },
          {
            id: 'btn-4',
            icon: '💹',
            title: 'Economy',
            link: '/subjects/economy',
            linkType: 'internal',
            color: '#96CEB4'
          }
        ]
      },
      styles: {
        buttonHeight: '120px',
        borderRadius: '12px',
        shadowLevel: 'sm'
      }
    },
    is_premium: true
  },

  {
    id: 'button-grid-resources-6',
    category: 'button_grid',
    name: 'Resource Hub',
    description: 'Six-button grid for comprehensive navigation',
    thumbnail: '/templates/button-grid-6.jpg',
    config: {
      type: 'button_grid',
      variant: 'default',
      props: {
        title: 'Learning Resources',
        subtitle: 'Everything you need in one place',
        columns: 3,
        gridSize: 6,
        gap: 16,
        buttons: [
          {
            id: 'btn-1',
            icon: '📖',
            title: 'Study Notes',
            link: '/materials',
            linkType: 'internal'
          },
          {
            id: 'btn-2',
            icon: '🎥',
            title: 'Video Lectures',
            link: '/videos',
            linkType: 'internal'
          },
          {
            id: 'btn-3',
            icon: '📊',
            title: 'Practice Tests',
            link: '/quiz',
            linkType: 'internal'
          },
          {
            id: 'btn-4',
            icon: '📰',
            title: 'Current Affairs',
            link: '/news',
            linkType: 'internal'
          },
          {
            id: 'btn-5',
            icon: '📈',
            title: 'My Progress',
            link: '/dashboard',
            linkType: 'internal'
          },
          {
            id: 'btn-6',
            icon: '💬',
            title: 'Discussion Forum',
            link: 'https://forum.clarityofconcept.com',
            linkType: 'external'
          }
        ]
      },
      styles: {
        buttonHeight: '110px',
        borderRadius: '12px',
        shadowLevel: 'md'
      }
    },
    is_premium: true
  },

  {
    id: 'button-grid-complete-8',
    category: 'button_grid',
    name: 'Complete Dashboard',
    description: 'Eight-button grid for full app navigation',
    thumbnail: '/templates/button-grid-8.jpg',
    config: {
      type: 'button_grid',
      variant: 'rounded',
      props: {
        title: 'Dashboard',
        subtitle: 'Access all features',
        columns: 4,
        gridSize: 8,
        gap: 12,
        buttons: [
          {
            id: 'btn-1',
            icon: '📚',
            title: 'Materials',
            link: '/materials',
            linkType: 'internal',
            iconSize: 'medium'
          },
          {
            id: 'btn-2',
            icon: '📝',
            title: 'Tests',
            link: '/quiz',
            linkType: 'internal',
            iconSize: 'medium'
          },
          {
            id: 'btn-3',
            icon: '🎥',
            title: 'Videos',
            link: '/videos',
            linkType: 'internal',
            iconSize: 'medium'
          },
          {
            id: 'btn-4',
            icon: '📊',
            title: 'Progress',
            link: '/dashboard',
            linkType: 'internal',
            iconSize: 'medium'
          },
          {
            id: 'btn-5',
            icon: '📰',
            title: 'News',
            link: '/news',
            linkType: 'internal',
            iconSize: 'medium'
          },
          {
            id: 'btn-6',
            icon: '🔔',
            title: 'Alerts',
            link: '/pulse',
            linkType: 'internal',
            iconSize: 'medium'
          },
          {
            id: 'btn-7',
            icon: '🏆',
            title: 'Achievements',
            link: '/achievements',
            linkType: 'internal',
            iconSize: 'medium'
          },
          {
            id: 'btn-8',
            icon: '⚙️',
            title: 'Settings',
            link: '/settings',
            linkType: 'internal',
            iconSize: 'medium'
          }
        ]
      },
      styles: {
        buttonHeight: '100px',
        borderRadius: '20px',
        shadowLevel: 'sm'
      }
    },
    is_premium: true
  },

  // Simple Text Card
  {
    id: 'text-card-simple',
    category: 'text_card',
    name: 'Simple Text Card',
    description: 'Clean text card with heading and formatted body text',
    thumbnail: '/templates/text-card.jpg',
    config: {
      type: 'text_card',
      props: {
        heading: 'Your Heading Here',
        headingFont: 'default',
        headingAlign: 'left',
        bodyText: '<p>Enter your text content here. Use the editor toolbar to add <strong>bold</strong>, <em>italic</em>, <u>underline</u>, and alignment.</p><p>You can also add lists, links, and blockquotes for rich formatting.</p>',
        bodyFont: 'default',
        borderRadius: 12,
        shadowLevel: 'md'
      },
      styles: {},
      responsive: { desktop: true, tablet: true, mobile: true }
    },
    is_premium: true
  }
];

// Template categories for filtering
export const templateCategories = [
  { id: 'all', name: 'All Templates' },
  { id: 'hero', name: 'Hero Sections' },
  { id: 'features', name: 'Feature Cards' },
  { id: 'button_grid', name: 'Button Grids' },
  { id: 'testimonials', name: 'Testimonials' },
  { id: 'cta', name: 'Call to Action' },
  { id: 'content', name: 'Content Blocks' },
  { id: 'text_card', name: 'Text Cards' }
];

// Helper function to get template by ID
export const getTemplateById = (id: string): Template | undefined => {
  return premiumTemplates.find(template => template.id === id);
};

// Helper function to get templates by category
export const getTemplatesByCategory = (category: string): Template[] => {
  if (category === 'all') return premiumTemplates;
  return premiumTemplates.filter(template => template.category === category);
};